/**
 * Return the menu
 * @param  {[type]} actualPage page where the user is
 * @param  {[type]} history    history function for navigation
 */
export const menuContent = () => []
